import type { IMenuItem } from '@/interfaces';

export interface IHeaderNavGroups {
  leftItems: IMenuItem[];
  rightItems: IMenuItem[];
}

/**
 * First menu item goes right (next to Profile), the rest left (beside the logo). Side is inferred
 * from Contentful order, so re-ordering the menu there is what moves an item between the two.
 *
 * TODO: replace with an explicit `headerPosition` field on the Contentful menu item.
 */
export const splitHeaderNavItems = (itemList: IMenuItem[] = []): IHeaderNavGroups => {
  const [firstItem, ...restItems] = itemList.filter((item) => !!item);

  return {
    leftItems: restItems,
    rightItems: firstItem ? [firstItem] : [],
  };
};
